import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
    selector: 'help-modal',
    templateUrl: './help-modal.component.html',
    styleUrls: ['./help-modal.component.scss'],
    standalone: false
})
export class HelpModalComponent implements OnInit {

    @Output() close: EventEmitter<null> = new EventEmitter();

    /**
     * CTOR
     */
    constructor() {
    }

    /**
     * On Init
     */
    ngOnInit() {
    }

    modalCleanup() {
        this.close.emit();
    }

}
